export const FloodAreaOptions = [
    { id: 1, name: 'IN Special Flood Hazard Area' },
    { id: 2, name: 'NOT IN Special Flood Hazard Area' },
];
